import { render, staticRenderFns } from "./sdwan_device_detail.vue?vue&type=template&id=06b7ae08&scoped=true"
import script from "./sdwan_device_detail.vue?vue&type=script&lang=js"
export * from "./sdwan_device_detail.vue?vue&type=script&lang=js"
import style0 from "./sdwan_device_detail.vue?vue&type=style&index=0&id=06b7ae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7ae08",
  null
  
)

export default component.exports